"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoValidAppCatelog = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const versionMetadata_1 = require("../../../../../common/versionMetadata");
const constants_1 = require("../utility/constants");
const errorCode = "NoValidAppCatelog";
const messageKey = "driver.spfx.error.noValidAppCatelog";
class NoValidAppCatelog extends teamsfx_api_1.UserError {
    constructor() {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, versionMetadata_1.MetadataV3.configFile),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, versionMetadata_1.MetadataV3.configFile),
        });
    }
}
exports.NoValidAppCatelog = NoValidAppCatelog;
//# sourceMappingURL=noValidAppCatelogError.js.map